import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useGoogleAds } from '../hooks/use-google-ads';

/**
 * Google Ads Tracker Component
 * Handles Google Ads initialization and automatic page view tracking
 */
const GoogleAdsTracker = () => {
  const location = useLocation();
  const { initializeAds, trackPageView } = useGoogleAds();

  // Initialize Google Ads on component mount
  useEffect(() => {
    initializeAds();
  }, [initializeAds]);

  // Track page views when location changes
  useEffect(() => {
    const pageTitle = document.title || 'Gravity Point Media';
    
    // Track page view for remarketing
    trackPageView(window.location.href, pageTitle);
  }, [location, trackPageView]);

  return null; // This component doesn't render anything
};

export default GoogleAdsTracker;
